module.exports = __webpack_public_path__ + "img/3.4490b91d.jpg";